import React, { Suspense } from "react";
import { Switch } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import { NigerianInstrumentsMenu } from "../../Common/layout/aside/aside-menu-lists/NigerianInstrumentsMenu";
import { AsideMenu } from "../../Common/layout/aside/AsideMenu";
import { Section } from "../../Common/layout/Section";
import { HoldingManagement } from "./Holdings";

export default function HoldingsManagementPages() {
  return (
    <>
      <AsideMenu>
        <NigerianInstrumentsMenu destination="/holdings" />
      </AsideMenu>
      <Section>
        <Suspense fallback={<LayoutSplashScreen />}>
          <Switch>
            <ContentRoute path="/holdings/:instrumentId" component={HoldingManagement} />
          </Switch>
        </Suspense>
      </Section>
    </>
  );
}
